import { Select, MenuItem, InputBase, withStyles } from "@material-ui/core";
import React from "react";

const styles = {
  input: {
    paddingBottom: "0px !important",
    fontSize: "14px",
    fontFamily: "mpsb",
    color: "#3E5574",
    "&:focus": {
      backgroundColor: "white"
    }
  },
  gutters: {
    paddingLeft: "12px !important",
    paddingRight: "12px !important"
  }
};

function YearMonthForm({ classes, date, localeUtils, onChange, tillYear }) {
  const months = localeUtils.getMonths();
  const shortMonths = months.map(m => m.substring(0, 3));
  const currentYear = new Date().getFullYear();
  const fromMonth = new Date(1925, 0);
  const toMonth = tillYear ? new Date(currentYear, 11) : new Date(2099, 11);

  const years = [];
  for (let i = toMonth.getFullYear(); i >= fromMonth.getFullYear(); i--) {
    years.push(i);
  }

  const handleMonthChange = event => {
    onChange(new Date(date.getFullYear(), event.target.value));
  };

  const handleYearChange = event => {
    onChange(new Date(event.target.value, date.getMonth()));
  };

  return (
    <form className="DayPicker-Caption">
      <Select
        className="dayPickerMonth"
        value={date.getMonth()}
        onChange={handleMonthChange}
        classes={{ icon: "mySelectIcon" }}
        input={
          <InputBase classes={{ input: classes.input }} disableUnderline />
        }
        disableUnderline
        MenuProps={{
          classes: { paper: classes.menuPaper },
          MenuListProps: { disablePadding: true },
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
          disablePortal: true,
          PaperProps: {
            style: {
              maxHeight: "none",
              overflowY: "visible",
              padding: 0,
              marginTop: 3
            }
          }
        }}
      >
        {shortMonths.map((month, i) => (
          <MenuItem
            key={month}
            value={i}
            style={{ paddingTop: 0, paddingBottom: 0, minHeight: "unset" }}
            classes={{ gutters: classes.gutters }}
          >
            {month}
          </MenuItem>
        ))}
      </Select>
      <Select
        className="dayPickerYear"
        value={date.getFullYear()}
        onChange={handleYearChange}
        classes={{ icon: "mySelectIcon" }}
        input={
          <InputBase classes={{ input: classes.input }} disableUnderline />
        }
        disableUnderline
        MenuProps={{
          classes: { paper: classes.menuPaper },
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
          disablePortal: true,
          PaperProps: {
            className: "scroll-container",
            style: {
              maxHeight: 290,
              marginTop: 4,
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              cursor: "pointer"
            }
          }
        }}
      >
        {years.map(year => (
          <MenuItem
            key={year}
            value={year}
            style={{ paddingTop: 0, paddingBottom: 0, minHeight: "unset" }}
            classes={{ gutters: classes.gutters }}
          >
            {year}
          </MenuItem>
        ))}
      </Select>
    </form>
  );
}

export default withStyles(styles)(YearMonthForm);
